import { Component, Input, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { getStage } from '../../store/selectors';
import { State, Stage } from '../../interfaces';
import { FlightsV2 } from '../../api/models';

@Component({
  selector: 'fin-upgrade-journey-info',
  templateUrl: 'journey-info.component.html',
})
export class JourneyInfoComponent implements OnInit {
  @Input()
  bounds: FlightsV2 = [];
  @Input()
  flightNumber = 0;
  @Input()
  isMultiCity = false;
  @Input()
  headingLevel: 2 | 3 = 3;

  currentStage$: Observable<Stage>;
  public readonly Stage = Stage;

  constructor(private store: Store<State>) {}

  ngOnInit(): void {
    this.currentStage$ = this.store.pipe(select(getStage));
  }

  get isDeparture(): boolean {
    return this.flightNumber === 1 && !this.isMultiCity;
  }

  get isReturn(): boolean {
    return this.flightNumber === 2 && !this.isMultiCity;
  }
}
